import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { isMobile } from 'react-device-detect'
import moment from 'moment'
import PdfViewer from '../../../../../module/pdf/PdfViewer'
import { alertActions, chempCertboxActions, modalActions } from '../../../../../store/actions'

const ChempRcvList = (props) => {
  const [isShowPdf, setIsShowPdf] = useState(false) //pdf버튼 버튼 표시 여부

  const [active, setActive] = useState()

  const [showResponse, setShowResponse] = useState()
  const [showFileNm, setShowFileNm] = useState()
  const [blobResponse, setBlobResponse] = useState()
  const [docid, setDocid] = useState()
  const [crtCd, setCrtCd] = useState()
  const [brno, setBrno] = useState()
  const [oldYn, setOldYn] = useState()
  const [fileId, setFileId] = useState()
  const [printYn, setPrintYn] = useState()
  const tabIdRef = useRef()

  useEffect(() => {
    if (props.tabId !== tabIdRef.current) {
      tabIdRef.current = props.tabId
    }
  }, [props.tabId])

  useEffect(() => {
    const fileList = props.CertboxInfo?.fileList
    const fileNewList = props.CertboxInfo?.fileNewList

    if (!fileList || !fileNewList) {
      //props.error({message: 'PDF 파일이 존재하지 않습니다.'});
      return
    }

  }, [props.CertboxInfo])

  const makeStatusBtn = (status) => {
    switch (status) {
      case '10':
        return <span className="text-blue">수취준비</span>
        break
      case '11':
        return <span className="text-red">수취오류</span>
        break
      case '12':
        return <span className="text-green">수취완료</span>
        break
      default:
        return <span className="text-black">상태미정{status}</span>
    }
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (crtCd, docid, brno, fileObj) => {
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }

    fileList.forEach((val, idx, arr) => {
      if (crtCd === '03' && fileList[idx].readYn === 'N') {
        const params = {
          docId: docid,
          fileId: fileList[idx].fileId,
          brno: brno,
        }
        props.getDownLoad(params)
      }

      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
        console.log(url)
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.open('GET', url)
        xhr.send()
        xhr.onload = function () {
          if (xhr.status === 200) {
            // HTTP가 잘 동작되었다는 뜻.
            console.log(window.URL.createObjectURL(xhr.response))
            setShowResponse(window.URL.createObjectURL(xhr.response))
            setBlobResponse(xhr.response)
            setShowFileNm(val['originFileNm'])
            setDocid(docid)
            setCrtCd(crtCd)
            setBrno(brno)
            setOldYn('N')
            setFileId(fileList[idx].fileId)
            setPrintYn(fileList[idx].printYn)
            setIsShowPdf(true)
          } else {
            props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
            return
          }
        }
      }, 1000)
    })
  }

  const eventHandler = (e, crtSeq) => {
    e.preventDefault()
    setActive(crtSeq)
    document.querySelectorAll('.attach-file').forEach((a)=>{
      if(a.id == crtSeq){
        a.className = 'attach-file active'
      }else{
        a.className = 'attach-file'
      }
    })
  }

  const onShowOut = (e) => {
    e.preventDefault()
    setActive('')
  }

  return (
    <>
      <div className="list-header">
        <span className="total-num">
          현재페이지 <em>{props.pagingInfo?.currentPage}</em>/{props.pagingInfo?.totalPage} {props.pagingInfo?.totalRecords}건
        </span>
        <span className="right btn-group">
          <a href="#" className="btn-gray sm">
            전자문서보관
          </a>
        </span>
      </div>
      <div className="tbl-wrap mobile-scroll">
        <table className="tbl-list">
          <caption>신청방법, 증명서 및 발급번호 항목으로 구성</caption>
          <colgroup>
            <col style={{ width: '15%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '10%' }} />
            <col />
          </colgroup>
          <thead>
            <tr>
              {/*<th scope="col">신청방법</th>*/}
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'DOCID')
                  }}
                >
                  증명서 및 발급번호
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'PRCHS_NM')
                  }}
                >
                  발급처
                </a>
              </th>
              {/*<th scope="col">제출처</th>*/}
              {/*/!*<th scope="col">*!/*/}
              {/*/!*  <a*!/*/}
              {/*/!*    href="./"*!/*/}
              {/*/!*    onClick={(e) => {*!/*/}
              {/*/!*      e.preventDefault()*!/*/}
              {/*/!*      props.onSelected(e, 'srhOrder', 'SUBMISSION')*!/*/}
              {/*/!*    }}*!/*/}
              {/*/!*  >*!/*/}
              {/*/!*    제출처*!/*/}
              {/*/!*  </a>*!/*/}
              {/*/!*</th>*!/*/}
              <th scope="col">업체명</th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'ISSUEDT')
                  }}
                >
                  발급일시
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'MOD_DT')
                  }}
                >
                  최종이력
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'STS')
                  }}
                >
                  상태
                </a>
              </th>
              <th scope="col">열람</th>
            </tr>
          </thead>
          <tbody>
            {props.data?.length > 0 ? (
              props.data?.map((certboxObj, index) => (
                <tr key={index}>

                  <td>
                    {certboxObj.crtNm} <span className="txt1">{certboxObj.docid}</span>
                  </td>
                  <td>{/*발급처 */}
                    {certboxObj.prchsNm}
                  </td>
                  {/*<td>/!* 제출처 *!/*/}
                  {/*  {certboxObj.submission}*/}
                  {/*</td>*/}
                  <td>{/* 업체명 */}
                    {certboxObj.orgNm}
                  </td>

                  <td>
                    {certboxObj.issuedt === null ||
                    moment(certboxObj?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss') === 'Invalid date'
                      ? '-'
                      : moment(certboxObj?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
                  </td>
                  <td>
                    {certboxObj.modDt === null || moment(certboxObj.modDt).format('YYYY.MM.DD HH:mm:ss') === 'Invalid date'
                      ? '-'
                      : moment(certboxObj.modDt).format('YYYY.MM.DD HH:mm:ss')}
                  </td>
                  <td>
                    {makeStatusBtn(certboxObj?.sts)}
                  </td>
                  <td>
                    {certboxObj.fileGroupId !== null && certboxObj.fileNewList?.length !== 0 && certboxObj.fileNewList?.length === 1 && (
                      <div className="attach-wrap">
                        {certboxObj.fileNewList?.map((fileObj, index) => (
                          <a
                            key={index}
                            href="#"
                            className="attach attach-link"
                            onClick={(e) => {
                              e.preventDefault()
                              onPdfDown(certboxObj.crtCd, certboxObj.docid, certboxObj.brno, fileObj)
                              return
                            }}
                          >
                            첨부
                          </a>
                        ))}
                      </div>
                    )}
                    {certboxObj.fileGroupId !== null && certboxObj.fileNewList?.length !== 0 && certboxObj.fileNewList?.length !== 1 && (
                      <div className="attach-wrap">
                        <a
                          href="#"
                          className="attach attach-link"
                          onClick={(e) => eventHandler(e, certboxObj.crtSeq + index)}
                          aria-expanded={active === certboxObj.crtSeq + index ? 'true' : 'false'}
                          aria-controls={certboxObj.crtSeq + index}
                          aria-disabled={active === certboxObj.crtSeq + index ? 'true' : 'false'}
                        >
                          첨부
                        </a>
                        <ul
                          id={certboxObj.crtSeq + index}
                          // className={active === certboxObj.crtSeq + index ? 'attach-file active' : 'attach-file'}
                          className='attach-file'
                        >
                          {certboxObj.fileNewList?.map((fileObj, index) => (
                            <li key={index}>
                              <a
                                onClick={(e) => {
                                  e.preventDefault()
                                  onPdfDown(certboxObj.crtCd, certboxObj.docid, certboxObj.brno, fileObj)
                            	  onShowOut(e)
                                  return
                                }}
                              >
                                {fileObj.originFileNm}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {certboxObj.fileGroupId === null && '-'}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="center" colSpan={7}>
                  <div className="nodata">조회 결과가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isShowPdf === true && (
        <PdfViewer
          blobResponse={blobResponse}
          showResponse={showResponse}
          fileNm={showFileNm}
          crtCd={crtCd}
          docid={docid}
          brno={brno}
          oldYn={oldYn}
          fileId={fileId}
          printYn={printYn}
          onClose={() => setIsShowPdf(false)}
        />
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    certboxInfo: state.certbox?.certboxInfo,
    isLoading: state.certbox?.isLoading,
    isCheckedDownloading: state.isCheckedDownloading,
  }
}

const actionCreators = {
  getcertboxInfo: chempCertboxActions.getcertboxInfo,
  changeSearchInfo: chempCertboxActions.changeSearchInfo,
  readcertboxList: chempCertboxActions.readCertboxList,
  getDownLoad: chempCertboxActions.getDownLoad,

  success: alertActions.success,
  confirm: alertActions.confirm,
  error: alertActions.error,

  showModalBagic: modalActions.showModalBagic,
  clearModal: modalActions.clearModal,
}

export default connect(mapStateToProps, actionCreators)(ChempRcvList)
